// @ts-strict-ignore
import {ParamComponent} from 'panel';

import {defineAndMakeJsxFactory} from 'common/util/jsx';
import {panel2react} from 'common/util/react';
import {IronContextRegistry} from 'common/report/context-registry';
import {Directions} from 'common/components/drop-menu/types';
import {ButtonSize, ButtonTheme} from 'common/components/button/constants';
import {MenuChangeEvent} from 'common/components/select/types';

import {template} from './template';
import css from './index.inline.styl';
import {ControlBarJsxProps, ControlBarParams, ControlBarState} from './types';

export class ControlBar extends ParamComponent<ControlBarParams, ControlBarState, IronContextRegistry> {
  get config() {
    return {
      defaultParams: {
        theme: ButtonTheme.Tertiary,
        size: ButtonSize.Medium,
        overflowIcon: `hor-ellipsis`,
        overflowMenuWidth: 160,
        overflowMenuHeight: 300,
        overflowMenuAlignment: Directions.Down,
        overflowControls: [],
      },

      params: {
        styleOverride: String,
        // interface: Section
        controls: Object,
        // Theme applied to untruncated buttons
        // enum: Object.values(ButtonTheme)
        theme: String,
        // Size applied to buttons
        // enum: Object.values(ButtonSize)
        size: String,
        // Custom overflow icon for the mp-select dropdown button
        overflowIcon: String,
        overflowTooltip: Object,
        overflowMenuWidth: Number,
        overflowMenuHeight: Number,
        // enum: Object.values(Directions)
        overflowMenuAlignment: String,
        disabled: Boolean,
        overflowControls: Array,

        onSelect: Function,
        onMenuChange: Function,
        onActionSelect: Function,
        onOverflowMenuClick: Function,
      },

      css,
      template,

      useShadowDom: true,
      contexts: [`i18n` as const],

      defaultState: {
        menuOpen: false,
      },
    };
  }

  public selectOption(value) {
    this.params.onActionSelect?.({value});
  }

  openMenu = () => this.update({menuOpen: true});

  getOverflowItems = () => {
    const items = this.params.overflowControls;
    const totalItems = items.reduce((a, section) => a + section.items.length, 0);

    if (totalItems < 1) {
      return [];
    }

    return items;
  };

  handleMenuClick = (ev) => {
    const {value, name, additionalInfo} = ev.detail.item;

    this.params.onActionSelect?.({value, name, additionalInfo});
    this.update({menuOpen: false});
  };

  handleMenuChange = (ev: MenuChangeEvent) => {
    this.params.onMenuChange?.(ev.detail.isOpen);
  };

  handleClick = (ev) => {
    const value = ev.target.getAttribute(`value`);
    this.selectOption(value);
  };

  handleOverflowMenuClick = () => {
    this.params.onOverflowMenuClick?.();
  };
}

export const ControlBarEl = defineAndMakeJsxFactory<ControlBarJsxProps>(`mp-control-bar`, ControlBar);
export const ControlBarReact = panel2react<ControlBarJsxProps>(`mp-control-bar`, ControlBar);
